import mapLimit from 'async/mapLimit'
import isEmpty from 'lodash/isEmpty'
import keyBy from 'lodash/keyBy'
import { api } from 'api'
import { registerList, getListData } from 'dataContainer/listDataManager'

export function getTemplateDependencies(id, template = {}) {
  return async dispatch => {
    await getTemplateDependenciesV2(dispatch, id, template)
  }
}

async function getTemplateDependenciesV2(dispatch, templateId, template) {
  const accountTemplateUrl = `/api/v1/account/template/${templateId}?with[]=folder:id,name`

  // if we have the template, we don't need to fetch it again
  const { data: templateData } = !isEmpty(template)
    ? { data: template }
    : await api.get(accountTemplateUrl)

  const { data: depsData } = await api.get(`/api/v2/account/template/${templateId}/dependencies`)

  mapLimit(
    depsData.listIds,
    3,
    (listId, cb) => {
      return fetchListDependency(templateId, listId).then(list => cb(null, list))
    },
    (err, lists) => {
      // mimic old contract so we can keep other logic the same
      const listsById = keyBy(lists, 'id')
      const dependencies = { ...depsData, lists: listsById }
      delete dependencies.listIds

      const transformedColumns = transformDeps(dependencies.columns, dependencies.lists)
      const result = {
        ...templateData,
        dependencies,
        transformedColumns,
      }

      dispatch({ type: 'SUBMISSION_TEMPLATE_LOADED', payload: result })
    },
  )
}

function fetchListDependency(templateId, listId) {
  return api
    .get(`/api/core/v1/templates/${templateId}/dependencies/lists/${listId}`)
    .then(response => response.data)
}

export function resetStore() {
  return dispatch => {
    dispatch({ type: 'RESET_STORE' })
  }
}

export function setDatasetMetadata(metadata) {
  return dispatch => {
    dispatch({ type: 'SET_DATASET_METADATA', payload: metadata })
  }
}

export function setShowHiddenColumns(datasetId, showHidden) {
  return dispatch => {
    dispatch({ type: 'SHOW_HIDDEN_COLUMNS', payload: { datasetId, showHidden } })
  }
}

export function setDatasetPendingRollup(data) {
  return dispatch => {
    dispatch({ type: 'SET_DATASET_PENDING_ROLLUP', payload: data })
  }
}

export function setDatasetDuplicatedRows(rows) {
  return dispatch => {
    dispatch({ type: 'SET_DATASET_DUPLICATED_ROWS', rows })
  }
}

export function transformDeps(columns, lists) {
  // extract all of the list values
  Object.keys(lists).forEach(listId => {
    const list = lists[listId]
    registerList(list)

    // prevent anyone from getting the list values off the original list reference
    delete list.list_values
  })

  // for now, we are going to merge the lists into the columns, so that the
  // object structure looks the same across the new and the old.
  ;(columns || []).forEach(templateField => {
    // get the list governance from the template field
    const listGovernance =
      templateField.list_governance || (templateField.field && templateField.field.list_governance)

    // if there isn't any list governance, nothing to add
    if (!listGovernance) {
      return
    }

    // clone the original list without the values (so we can do it by reference)
    const originalList = lists[listGovernance.list_id] || { list_columns: [] }
    const {
      list_values: _list_values,
      list_columns: _list_columns,
      ...listWithoutValues
    } = originalList
    const clonedWithoutValues = JSON.parse(JSON.stringify(listWithoutValues))

    // replace lists prop
    listGovernance.lists = clonedWithoutValues

    if (listGovernance.hierarchy) {
      const listData = getListData(listGovernance.list_id)
      const { rows } = listData
      listGovernance.lists.possible_hierarchy_values = []

      for (let i = 0; i < rows.length; i++) {
        for (let o = 0; o < rows[i].length; o++) {
          listGovernance.lists.possible_hierarchy_values.push(
            rows[i].slice(0, o + 1).join(listGovernance.indicator),
          )
        }
      }
    }

    // add list_column
    listGovernance.list_column =
      originalList.list_columns.find(listCol => {
        return listCol.id === listGovernance.list_column_id
      }) || {}
  })
  return columns
}
